// Inline field-level validation helpers. Adds .has-error class + a sibling
// .field-error span below the input so users see the message next to the
// offending field instead of relying solely on toast.

export function setFieldError(input: HTMLElement, message: string | null): void {
  input.classList.toggle('has-error', !!message);
  const parent = input.parentElement;
  if (!parent) return;
  let err = parent.querySelector<HTMLElement>('.field-error');
  if (!message) {
    err?.remove();
    return;
  }
  if (!err) {
    err = document.createElement('span');
    err.className = 'field-error';
    parent.appendChild(err);
  }
  err.textContent = message;
}

export function clearFieldErrors(scope: HTMLElement): void {
  scope.querySelectorAll<HTMLElement>('.has-error').forEach((el) => el.classList.remove('has-error'));
  scope.querySelectorAll<HTMLElement>('.field-error').forEach((el) => el.remove());
}
